module.exports = __webpack_public_path__ + "img/tea_left.797e1c6b.png";